module.exports = __webpack_public_path__ + "static/media/20.4c7e4e2d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/moan/20.mp3
// module id = 496
// module chunks = 0